import { Box, Flex, useColorModeValue } from '@chakra-ui/react'
import { Outlet } from 'react-router-dom'
import { Navbar } from '../components/navigation/Navbar'
import { Sidebar } from './Sidebar'

export const MainLayout = () => {
  const bg = useColorModeValue('gray.50', 'gray.900')
  
  return (
    <Flex h="100vh">
      <Sidebar />
      <Flex direction="column" flex="1">
        <Navbar />
        <Box flex="1" p={4} bg={bg}>
          <Outlet />
        </Box>
      </Flex>
    </Flex>
  )
}
